import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/bind_img.png';

const _withScopeId = n => (_pushScopeId("data-v-f9eea30e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "card-box"
};
const _hoisted_2 = {
  class: "online-card"
};
const _hoisted_3 = {
  key: 0,
  class: "online-link"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://passport.zhihuishu.com/login?service=https://login.polymas.com/zhslogin?redirect=https://hike-teaching-center.polymas.com/tchCourse",
  class: "new-path",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "path-tips"
}, [/*#__PURE__*/_createElementVNode("p", null, "新版学堂"), /*#__PURE__*/_createElementVNode("div", {
  class: "btn"
}, [/*#__PURE__*/_createTextVNode(" 进入 "), /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-icon"
})])])], -1));

const _hoisted_5 = ["href"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "path-tips"
}, [/*#__PURE__*/_createElementVNode("p", null, "旧版学堂"), /*#__PURE__*/_createElementVNode("div", {
  class: "btn"
}, [/*#__PURE__*/_createTextVNode(" 进入 "), /*#__PURE__*/_createElementVNode("span", {
  class: "arrow-icon"
})])], -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "left"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "在线学堂", -1));

const _hoisted_10 = ["href"];
const _hoisted_11 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "left"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "menu-title"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu arrow-icon"
}, null, -1));

const _hoisted_17 = {
  key: 1,
  class: "menu-card"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "card-text"
};
const _hoisted_21 = {
  key: 1,
  class: "bind-box"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "bind-img",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "bind-tips"
}, [/*#__PURE__*/_createElementVNode("div", null, "绑定智慧树账号"), /*#__PURE__*/_createElementVNode("div", null, "优享更多服务")])], -1));

const _hoisted_23 = /*#__PURE__*/_createTextVNode("去绑定 >");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_TipDialog = _resolveComponent("TipDialog");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.zhsRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("a", {
    href: $props.onlineLink,
    target: "_blank",
    class: "old-path"
  }, _hoisted_7, 8, _hoisted_5)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createElementVNode("a", {
    href: $props.onlineLink,
    target: "_blank",
    class: "online-link"
  }, "进入 >", 8, _hoisted_10)]))]), $options.uuid() ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.zhsRole == 3 || $props.zhsRole == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "menu-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: item.icon_url,
      alt: "",
      class: "menu-icon"
    }, null, 8, _hoisted_14), _createElementVNode("span", _hoisted_15, _toDisplayString(item.app_name), 1)]), _hoisted_16], 8, _hoisted_12);
  }), 128))])) : (_openBlock(), _createElementBlock("ul", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.menuList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: "card-item",
      key: item.name,
      onClick: $event => $options.handleLink(item.jump_url)
    }, [_createElementVNode("img", {
      src: item.icon_url,
      class: "card-icon",
      alt: ""
    }, null, 8, _hoisted_19), _createElementVNode("span", _hoisted_20, _toDisplayString(item.app_name), 1)], 8, _hoisted_18);
  }), 128))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createVNode(_component_el_button, {
    class: "bind-btn",
    type: "primary",
    round: "",
    onClick: $options.goToBind
  }, {
    default: _withCtx(() => [_hoisted_23]),
    _: 1
  }, 8, ["onClick"])]))]), _createVNode(_component_TipDialog, {
    show: $data.showDialog,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.showDialog = $event)
  }, null, 8, ["show"])], 64);
}